import "./App.css";
import { Route, Routes } from "react-router-dom";
import AppFooter from "./Components/AppFooter";
import AppHeader from "./Components/AppHeader";
import PageContent from "./Components/PageContent";
import SideMenu from "./Components/SideMenu";
import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import { Layout } from "antd";
import { useGlobalContext } from "./providers/GlobalProvider";
import Verify from "./Pages/Verify";

function App() {
  const {isLoggedIn} = useGlobalContext();

  return (
    <>
      {isLoggedIn? (<div className="App">
        <Layout style={{minHeight: '100%'}}>
          <AppHeader />
          <Layout className="SideMenuAndPageContent">
            <SideMenu></SideMenu>
            <PageContent ></PageContent>
          </Layout>
          <AppFooter />
        </Layout>
      </div>): 
       (<Routes>
            <Route path="/" element={<Login />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/register" element={<SignUp />}></Route>
            <Route path="/register-verify" element={<Verify />}></Route>
        </Routes>)
      }
    </>
  );
}
export default App;
